import React, { useContext } from "react";
import * as tasks from "../extended/June2025Tasks";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import MaturaOriginalSourceLinks from "../../components/MaturaOriginalSourceLinks";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";

export const sheet = { id: "cke-r-2025-czerwiec", title: "Matura rozszerzona — czerwiec 2025",
  subtitle: "Formuła 2023 · 13 punktowanych części · 50 punktów", sourceLabel: "CKE · czerwiec 2025 · rozszerzenie",
  taskCount: 13, maxPoints: 50, sessionType: "additional" };
const taxonomy = { "1": ["8:1", null], "2": ["9:0", "10_1_2"], "3": ["8:0", "9_1_1"],
  "4": ["9:1", "10_2_1"], "5": ["2:3", "3_3_7"], "6": ["4:2", "5_3_2"],
  "7": ["5:2", "6_3_3"], "8": ["2:5", "3_7_2"], "9": ["3:2", "4_3_2"],
  "10": ["7:1", null], "11": ["6:2", "7_3_3"], "12.1": ["9:1", "10_2_3"], "12.2": ["2:5", "3_7_4"] };
export const classification = tasks.taskNumbers.map(taskNo => ({ taskNo,
  maxPoints: tasks.definitions[taskNo].points, familyKey: tasks.definitions[taskNo].family, topic: tasks.definitions[taskNo].topic, status: "ready",
  topicKey: taxonomy[taskNo][0], subtopicId: taxonomy[taskNo][1], sectionKey: String(Number(taxonomy[taskNo][0].split(":")[0]) + 1) }));
export function generateTaskVariant(number, variant = "random", options = {}) {
  number = String(number);
  if (number.startsWith("12.") && !options.single) {
    const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
    const linkedTasks = ["12.1", "12.2"].map(n => generateTaskVariant(n, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === number), linkedTasks };
  }
  const task = tasks.generateTask(number, { ...options, variant });
  return { index: tasks.taskNumbers.indexOf(number), task: { ...task, displayBaseNumber: Number(number.split(".")[0]) },
    meta: { ...classification.find(row => row.taskNo === number), quizTypeKey: task.type, quizKind: "open", assessmentMode: "self" } };
}
export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return tasks.taskNumbers.map(number => generateTaskVariant(number, variant, { ...options, single: true, seed: `${seed}:${number.startsWith("12.") ? "prism" : number}` }));
}
export function generateTasks(variant, options) { return generatePagedTasks(variant, options).map(row => row.task); }
export const getVariantCounts = tasks.getVariantCounts;
function OriginalLink({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  return <MaturaPdfPreview url={tasks.pdfUrl("arkusz", task.taskNumber)} title={`Arkusz CKE · czerwiec 2025 · zadanie ${task.taskNumber}`} label="Zadanie w oryginalnym PDF · czerwiec 2025"/>;
}
export function renderTask(task) { return <>{tasks.renderTask(task)}<MaturaOriginalSourceLinks task={task}/><OriginalLink task={task}/></>; }
export const renderInput = tasks.renderInput;
export const checkAnswer = tasks.checkAnswer;
export const renderAnswer = tasks.renderAnswer;
export const renderExplanation = tasks.renderExplanation;
export const renderUserAnswer = tasks.renderUserAnswer;
export function getInteractionSupport() { return { renderInput: true, checkAnswer: true, renderUserAnswer: true }; }
